const overlayFormat = {
	main: {
		position: 'fixed',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
	},

	backdropStyle: {
		position: 'fixed',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
		zIndex: 'auto',
		backgroundColor: 'black',
		opacity: 0.7,
	},

	modalSection: {
		position: 'absolute',
		width: '90%',
		maxHeight: '90%',
		top: '4.5em',
		left: '50%',
		transform: `translate(-${50}%, -${0}%)`,
		border: '1px solid #e5e5e5',
		backgroundColor: 'white',
		boxShadow: '0 5px 15px rgba(0,0,0,.5)',
		overflowY: 'auto',
		overflowX: 'hidden',
	},

	loginSection: {
		position: 'absolute',
		top: '20px',
		left: '50%',
		transform: `translate(-${50}%, -${0}%)`,
		border: '1px solid #e5e5e5',
		backgroundColor: 'white',
		boxShadow: '0 5px 15px rgba(0,0,0,.5)',
	},

	storeModal: {
		position: 'absolute',
		width: '370px',
		// this index must be higher than the fullscreen style for the
		// HomeContainer, but cannot go over 2000 or the drop down
		// menu items will not show.
		zIndex: 1600,
		top: '15%',
		bottom: 0,
		left: 'calc(50vw - 170px)',
	},
};
export default overlayFormat;
